import { PayloadAction } from "@reduxjs/toolkit";
import { ArticleDetailInterface } from "@/components/ArticlePage/api/interface";
import { ArticleState } from "@/components/ArticlePage/redux/types";

const ArticleReducer = {
  setArticleData: (state: ArticleState, action: PayloadAction<ArticleDetailInterface>) => {
    state.articleData = action.payload;
  },
  setLoading: (state: ArticleState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setDevice: (state: ArticleState, action: PayloadAction<any>) => {
    state.ua = action.payload;
  },
  setError: (state: ArticleState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
  setArticleSlug: (state: ArticleState, action: PayloadAction<string>) => {
    state.articleSlug = action?.payload;
  },
};

export default ArticleReducer;
